import { Service } from '@roc/feature-app-core';

const url = {
  GET_SERVICING_DASHBOARD: '/api/v1/loan/specialServicing/getServicingDashboard',
  EXPORT_SERVICING_DASHBOARD: '/api/v1/loan/specialServicing/exportServicingDashboard',
  GET_INVESTOR_NAMES: '/api/v1/loan/specialServicing/getInvestorNames',
  PERFORM_RECEIVABLE_ACTION: '/api/v1/loan/specialServicing/performReceivableAction',
  PERFORM_RECEIVABLE_BILLS_ACTION: '/api/v1/loan/specialServicing/performReceivableBillsAction',
  PERFORM_PAYABLE_ACTION: '/api/v1/loan/specialServicing/performPayableAction',
  GET_VENDOR_NAMES: '/api/v1/loan/specialServicing/getVendorNames',
  GET_PAYABLES_DATA: '/api/v1/loan/specialServicing/getPayablesData',
  ADD_PROTECTIVE_ADVANCE: '/api/v1/loan/specialServicing/saveProtectiveAdvance',
  DOWNLOAD_BILL_DOCUMENT_BUNDLE: '/api/v1/loan/specialServicing/downloadBillDocuments',
  MARK_PAYABLE_AS_PAID: '/api/v1/loan/specialServicing/markPayableAsPaid',
  UPDATE_COMMENTS: '/api/v1/loan/specialServicing/updateComments',
  GET_ATTESTATION_DASHBOARD: '/api/v1/loan/specialServicing/getAttestationDashboard',
  ATTEST: '/api/v1/loan/specialServicing/attestPayable',
  DOWNLOAD_TAX_REPORT: '/api/v1/loan/specialServicing/downloadTaxReport',
  UPLOAD_REFUNDS_FILE: '/api/v1/loan/specialServicing/uploadRefundsFile',
  DOWNLOAD_REFUNDS_REPORT: '/api/v1/loan/specialServicing/downloadRefundsReport',
  GET_REFUND_ENTITIES: '/api/v1/loan/specialServicing/getRefundEntities',
  DOWNLOAD_INVOICES_REPORT_BUNDLE: '/api/v1/loan/specialServicing/downloadInvoicesReport',
  PERFORM_VENDOR_PAYMENT_ACTION: '/api/v1/loan/specialServicing/performVendorPaymentAction',
  REMOVE_PAYABLE_FROM_PAYMENT: '/api/v1/loan/specialServicing/removePayableFromVendorPayment',
  DOWNLOAD_VENDOR_PAYMENT_DOCUMENT_BUNDLE: '/api/v1/loan/specialServicing/downloadVendorPaymentDocuments',
  REMOVE_RECEIVABLE_FROM_BILL: '/api/v1/loan/specialServicing/removeReceivableFromBill',
  GET_SERVICING_TRANSFERS_DASHBOARD: '/api/v1/loan/specialServicing/getServicingTransfersDashboard',
  GET_BOARDED_SERVICING_TRANSFERS_DASHBOARD: '/api/v1/loan/specialServicing/getBoardedServicingTransfersDashboard',
  MARK_BOARDING_PACKAGE_AS_SENT: '/api/v1/loan/specialServicing/markBoardingPackageAsSent',
  DOWNLOAD_SERVICING_TRANSFER_REPORT: '/api/v1/loan/specialServicing/downloadServicingTransferReports',
  DOWNLOAD_BOARDED_REPORT: '/api/v1/loan/specialServicing/exportHistoricBoardedServicingTransfers',
  CREATE_CREDIT_MEMO_FROM_PAYABLES: '/api/v1/loan/specialServicing/createCreditMemoFromPayables',
  UPDATE_PAYABLE_ADJUSTEMT: '/api/v1/loan/specialServicing/updatePayableAdjustment',
  UPDATE_RECEIVABLE_ADJUSTMENT: '/api/v1/loan/specialServicing/updateReceivableAdjustment',
  DOCUMENT_DETAILS: '/nportal/rest/priv/loanDocs/getLoanDocumentById',
  GET_PRINCIPAL_AMORTIZATION_DATA: '/api/v1/loan/specialServicing/getPrincipalAmortizationData',
  GET_PAYABLE_HISTORY: '/api/v1/loan/specialServicing/getPayableHistory',
  GET_RECEIVABLE_HISTORY: '/api/v1/loan/specialServicing/getReceivableHistory',
};

export class SpecialServicingService extends Service {

  getCounterPartyExpensesData(
    type: string,
    param: string,
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object
  ) {
    return this.get(
      url.GET_SERVICING_DASHBOARD,
      {
        type,
        param,
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getAttestationDashboard(
    loanId: number,
    type: string,
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object
  ) {
    return this.get(
      url.GET_ATTESTATION_DASHBOARD,
      {
        loanId,
        type,
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  exportServicingDashboardData(
    type: string,
    param: string,
    filters: object,
    dropdownFilters: object) {
    return this.get(
      `${url.EXPORT_SERVICING_DASHBOARD}`,
      {
        type,
        param,
        filters,
        dropdownFilters
      },
      {
        responseType: 'arraybuffer',
      }
    );
  };

  downloadBillDocuments(billIds: number[]) {
    return this.get(`${url.DOWNLOAD_BILL_DOCUMENT_BUNDLE}?servicingBillIds=${billIds}`, {},
      {
        responseType: 'arraybuffer',
      }
    );
  };

  downloadVendorPaymentDocuments(vendorPaymentIds: number[]) {
    return this.get(`${url.DOWNLOAD_VENDOR_PAYMENT_DOCUMENT_BUNDLE}?vendorPaymentIds=${vendorPaymentIds}`, {},
      {
        responseType: 'arraybuffer',
      }
    );
  };

  downloadInvoicesReport(billIds: number[]) {
    return this.get(`${url.DOWNLOAD_INVOICES_REPORT_BUNDLE}?servicingBillIds=${billIds}`, {},
      {
        responseType: 'arraybuffer',
      }
    );
  };

  getInvestorNames() {
    return this.get(url.GET_INVESTOR_NAMES, {},
      {
        disableGlobalLoading: true,
      }
    );
  }

  performReceivableAction(data, status) {
    return this.put(
      `${url.PERFORM_RECEIVABLE_ACTION}?status=${status}`,
      data
    );
  }

  performReceivableBillsAction(recordId, status, date) {
    let parameter = date == null ? '' : `&actionDate=${date}`;
    return this.put(
      `${url.PERFORM_RECEIVABLE_BILLS_ACTION}/${recordId}?status=${status}${parameter}`, null
    );
  }

  performPayableAction(data, status) {
    return this.put(
      `${url.PERFORM_PAYABLE_ACTION}?status=${status}`,
      data
    );
  }

  attest(loanId, type) {
    return this.put(
      `${url.ATTEST}/${loanId}?type=${type}`, null
    );
  }


  getPayablesData(
    type: string,
    entity: string,
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object
  ) {

    const queryParams = { type, entity, page, pageSize, sortDir, sortBy, filters };
    const metadata = { disableGlobalLoading: true };

    return this.get(url.GET_PAYABLES_DATA, queryParams, metadata);
  }

  getVendorsNames() {
    return this.get(url.GET_VENDOR_NAMES, {}, { disableGlobalLoading: true });
  }

  saveProtectiveAdvance(
    payableId: any,
    loanId: string,
    invoice: string,
    amount: string,
    typeOfFee: string,
    vendorId: string,
    internalInvoice: any,
    file: File,
  ) {
    const formData = new FormData();
    payableId && formData.append('payableId', payableId)
    formData.append('loanId', loanId);
    formData.append('invoice', invoice);
    formData.append('amount', amount);
    formData.append('typeOfFee', typeOfFee);
    formData.append('vendorId', vendorId);
    formData.append('internalInvoice', internalInvoice);
    formData.append('file', file);
    return this.post(url.ADD_PROTECTIVE_ADVANCE, formData);
  };

  markPayableAsPaid(data, reference) {
    return this.put(
      `${url.MARK_PAYABLE_AS_PAID}?reference=${reference}`,
      data
    );
  }

  updateComments(recordId, comments, type) {
    return this.put(
      `${url.UPDATE_COMMENTS}/${recordId}?comments=${comments}&type=${type}`, null
    );
  }

  downloadTaxReport(data) {
    return this.post(
      `${url.DOWNLOAD_TAX_REPORT}`,
      data, null,
      {
        responseType: 'arraybuffer',
      }
    );
  }

  uploadRefundsFile(
    payerCompanyId: string,
    file: File,
  ) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('payerCompanyId', payerCompanyId);

    return this.post(url.UPLOAD_REFUNDS_FILE, formData);
  };

  downloadRefundsReport(data) {
    return this.post(
      `${url.DOWNLOAD_REFUNDS_REPORT}`,
      data, null,
      {
        responseType: 'arraybuffer',
      }
    );
  }

  getRefundEntities() {
    return this.get(url.GET_REFUND_ENTITIES, {}, { disableGlobalLoading: true });
  }

  performVendorPaymentAction(data, status, param) {
    return this.put(
      `${url.PERFORM_VENDOR_PAYMENT_ACTION}?status=${status}&actionParam=${param}`,
      data
    );
  }

  removeFromVendorPayment(payableId) {
    return this.put(
      `${url.REMOVE_PAYABLE_FROM_PAYMENT}?payableId=${payableId}`,
      {}
    );
  }

  removeReceivableFromBill(receivableId, comment?: string) {
    return this.put(
      `${url.REMOVE_RECEIVABLE_FROM_BILL}?receivableId=${receivableId}&comment=${encodeURIComponent(comment ?? '')}`,
      {}
    );
  }

  getServicingTransfersDashboard(
    fromDate: string,
    toDate: string,
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object
  ) {
    return this.get(
      url.GET_SERVICING_TRANSFERS_DASHBOARD,
      {
        fromDate,
        toDate,
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  getBoardedServicingTransfersDashboard(
    fromDate: string,
    toDate: string,
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object
  ) {
    return this.get(
      url.GET_BOARDED_SERVICING_TRANSFERS_DASHBOARD,
      {
        fromDate,
        toDate,
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  markBoardingPackageAsSent(loanIds, date) {
    return this.post(`${url.MARK_BOARDING_PACKAGE_AS_SENT}?date=${date}`, loanIds);
  }

  downloadServicingTransferReports(data) {
    return this.post(
      `${url.DOWNLOAD_SERVICING_TRANSFER_REPORT}`,
      data, null,
      {
        responseType: 'arraybuffer',
      }
    );
  }

  exportHistoricBoardedServicingTransfers(
    fromDate,
    toDate,
    filters,
    dropdownFilters,
  ) {
    return this.get(
      `${url.DOWNLOAD_BOARDED_REPORT}`,
      {
        fromDate,
        toDate,
        filters,
        dropdownFilters
      },
      {
        responseType: 'arraybuffer',
      }
    );
  }

  createCreditMemoFromPayables(data, amount, comment) {
    return this.post(
      `${url.CREATE_CREDIT_MEMO_FROM_PAYABLES}?amount=${amount}&comment=${comment}`,
      data
    );
  }

  createCreditMemoFromPayable(data) {
    return this.post(
      url.CREATE_CREDIT_MEMO_FROM_PAYABLES,
      data
    );
  }

  updatePayableAdjustment(payableId, adjustment, comment) {
    return this.post(
      `${url.UPDATE_PAYABLE_ADJUSTEMT}?payableId=${payableId}&adjustment=${adjustment}&comment=${comment}`,
      null
    );
  }

  updateReceivableAdjustment(receivableId, adjustment, comment) {
    return this.post(
      `${url.UPDATE_RECEIVABLE_ADJUSTMENT}?receivableId=${receivableId}&adjustment=${adjustment}&comment=${comment}`,
      null
    );
  }

  getDocumentDetails(loanDocumentId: number) {
    return this.get(url.DOCUMENT_DETAILS, {
      loanDocumentId
    });
  }

  getPayableHistory(payableId: number | string) {
    return this.get(url.GET_PAYABLE_HISTORY, { payableId }, { disableGlobalLoading: true });
  }

  getReceivableHistory(receivableId: number | string) {
    return this.get(url.GET_RECEIVABLE_HISTORY, { receivableId }, { disableGlobalLoading: true });
  }

  getLoanAmortizationDetails(
    loanId: any,
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object
  ) {
    return this.get(
      url.GET_PRINCIPAL_AMORTIZATION_DATA,
      {
        loanId,
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters
      },
      {
        disableGlobalLoading: true,
      }
    );
  }
}
